import React, { useRef, useState } from "react";

//Images
import forgotImage from "../../assets/images/otp.svg";
import lockImage from "../../assets/images/lock.svg";
import { useFormik } from "formik";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import AuthService from "../../services/AuthService";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import LogoImg from "../../assets/images/Main-Logo.png";
import * as Yup from "yup";
import { toast } from "react-toastify";
import HelmetBase from "../../components/HelmetBase";

const Otp = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const paramValue = searchParams.get("email");

  const inputs = useRef([]);

  const [otp, setOtp] = useState(new Array(4).fill(""));

  const [error, setError] = useState();

  const [loading, setLoading] = useState(false);

  const handleInputChange = (e, index) => {
  const value = e.target.value;

  if (!/^\d*$/.test(value)) return;

  const newOtp = [...otp];
  newOtp[index] = value;
  setOtp(newOtp);

  const fullOtp = newOtp.join("");
  formik.setFieldValue("otp", fullOtp);

  if (/^\d$/.test(value) && index < 3) {
    inputs.current[index + 1].focus();
  }
};


  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      inputs.current[index - 1].focus();
    }
  };

  const validationSchema = Yup.object({
    otp: Yup.string()
      .required(t("OTP Required")),
  });

  const formik = useFormik({
    initialValues: {
      otp: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const fullOtp = otp.join("");

      values.otp = fullOtp;

      const data = {
        ...values,
        email: paramValue,
      };

      try {
        setLoading(true);
        const res = await AuthService.otpVerify(data);

        setOtp(["", "", "", ""]);
        inputs.current.forEach((input) => {
          if (input) input.value = "";
        });
        if (inputs.current[0]) inputs.current[0].focus();

        if (res.status == 1) {
          setLoading(false);
          navigate(`/reset-password?email=${paramValue}`);
        } else {
          setLoading(false);
          setError(t("Invalid OTP or OTP Expired"));
        }
      } catch (error) {
        console.log("error", error);
        setLoading(false);
        setError(t("Invalid OTP or OTP Expired"));

        setOtp(["", "", "", ""]);
        inputs.current.forEach((input) => {
          if (input) input.value = "";
        });
        if (inputs.current[0]) inputs.current[0].focus();
      }
    },
  });

  const resendOTP = async () => {
    const data = {
      mobile_number: paramValue,
    };
    setLoading(true);
    try {
      await AuthService.resendOTP(data)
        .then((res) => {
          if (res?.data?.status == 1) {
            setLoading(false);
            toast.success(res?.data?.message);
          } else {
            setLoading(false);
            toast.success(res?.data?.message);
          }
        })
        .catch((err) => {
          console.log("ERROR", err);
          setLoading(false);
        });
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <>
      <HelmetBase
        title={`${t("Reset Password")}`}
        name={`${t("Reset Password")}`}
      />
      <div className="container-fluid">
        <div className="row login-container">
          <div className="col-md-6 left-side">
            <img
              src={forgotImage}
              alt="Login Illustration"
              className="login-image"
            />
          </div>

          <div className="col-md-6 right-side">
            <div className="login-form">
              <div className="brand-logo d-flex justify-content-center mb-5">
                <Link to="/">
                  <img src={LogoImg} alt="" />
                </Link>
              </div>
              <div className="head-contant">
                <div className="head-image">
                  <img src={lockImage} alt="" />
                </div>
                <div className="head-text">
                  <h1>{t("Verify Code")}</h1>
                  <p>
                    {t("Please enter the code we just have sent to")}
                    <strong> {paramValue}</strong>
                  </p>
                </div>
              </div>
              <Form onSubmit={formik.handleSubmit}>
                <div
                  className="mb-3 otp-input-container d-flex justify-content-between"
                  style={{ gap: "20px" }}
                >
                  {otp.map((_, index) => (
                    <input
                      key={index}
                      type="tel"
                      maxLength="1"
                      ref={(el) => (inputs.current[index] = el)}
                      onChange={(e) => handleInputChange(e, index)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      className="form-control otp-box text-center"
                    />
                  ))}
                </div>
                {error && <p className="text-danger">{error}</p>}
                {formik.touched.otp && formik.errors.otp && (
                  <div className="text-danger text-center">{formik.errors.otp}</div>
                )}
                {/* {formik.touched.otp && formik.errors.otp && (
                  <div className="text-danger">{formik.errors.otp}</div>
                )} */}

                <button
                  type="submit"
                  className="btn btn-primary w-100 mb-2"
                  disabled={loading ? true : false}
                >
                  {!loading ? `${t("Verify")}` : `${t("Loading...")}`}
                </button>

                {/* <p className="text-center mt-2" style={{ color: "#626262" }}>
                  {t("You can resend the code in 56 seconds")}
                </p> */}
                <p
                  className="text-center"
                  style={{ color: "#837fd8" }}
                  onClick={() => resendOTP()}
                >
                  {t("RESEND CODE")}
                </p>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Otp;
